import React from 'react'
import PropTypes from 'prop-types'
import { I18N } from 'commons'


const getFileDownloadURL = (file) =>
  `/download/attachment/${file.fileId}/${file.image ? 1 : 3}`

const AttachmentList = ({ files }) =>
  files.length > 0 && [
    <hr key="attachment-list-hr" />,
    <div
      key="attachment-list"
      className="attachment-list"
      data-testid="ee_notificationDetail_field_attachment"
    >
      <I18N tag="h3" id="attachmentTitle">
        notification.field.attachment
      </I18N>
      <ul aria-labelledby="attachmentTitle">
        {files.map((file) => (
          <li key={`attachment-${file.fileId}`}>
            <a
              href={getFileDownloadURL(file)}
              className="text-decaration"
            >
              {file.fileName}
            </a>
          </li>
        ))}
      </ul>
    </div>,
  ]

AttachmentList.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      fileId: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      fileType: PropTypes.string,
      image: PropTypes.bool,
    })
  ).isRequired,
}

export default AttachmentList
